<template>
  <div class="loading-container">
    <div v-if="isFetching" class="loading-overlay">
      <div class="loader"></div>
    </div>
  <span v-else v-show="isShowPage">
    <v-row class="d-flex justify-end">
      <!-- <v-col class="text-left">
        <span>Filter berdasarkan kategori
          <v-chip
            class="ma-2"
            close
            color="green"
            outlined
          >
            Jumlah Transaksi > 500
          </v-chip>
        </span>
        <span v-if="items.length > 0">: {{ items.length + 1 + ' data ditemukan' }}</span>
      </v-col> -->
      <v-col cols="12" class="d-flex justify-end justify-content-center">
        <!-- <span v-if="items.length > 0">{{ items.length + 1 + ' data ditemukan' }}</span> -->
        <v-btn
          class="ma-2 mr-3"
          depressed
          outlined
          :color="colorActive"
          @click="
            openDialogFilter();
            triggerAuto();
          "
        >
          <v-icon left :color="colorActive"> $ic-filter </v-icon>
          Filter
        </v-btn>
        <v-switch :input-value="switchMe" @change="triggerAuto()">
          <template v-slot:label> AutoRefresh </template>
        </v-switch>
        <!-- <v-switch  v-model="switchMe" @change="triggerAuto()">
          <template v-slot:label>
            AutoRefresh
          </template>
        </v-switch> -->
      </v-col>
    </v-row>
    <v-row> </v-row>
    <v-row>
      <v-col>
        <!-- <v-alert border="bottom" colored-border color="#397E5D" elevation="2"> -->
        <v-row class="green-xcards ml-2 mr-2">
          <v-col cols="12">
            <span class="summary-alert-title">Available Charger</span>
          </v-col>
          <v-col cols="12">
            <span class="summary-alert-value">{{ cardItems.hijau }}</span>
          </v-col>
        </v-row>
        <!-- </v-alert> -->
      </v-col>
      <v-col>
        <!-- <v-alert border="bottom" colored-border color="#FFD600" elevation="2"> -->
        <v-row class="yellow-xcards ml-2 mr-2">
          <v-col cols="12">
            <span class="summary-alert-title">In Use Charger</span>
          </v-col>
          <v-col cols="12">
            <span class="summary-alert-value">{{ cardItems.kuning }}</span>
          </v-col>
        </v-row>
        <!-- </v-alert> -->
      </v-col>
      <v-col>
        <!-- <v-alert border="bottom" colored-border color="#FFD600" elevation="2"> -->
        <v-row class="red-xcards ml-2 mr-2">
          <v-col cols="12">
            <span class="summary-alert-title">Unavailable Charger</span>
          </v-col>
          <v-col cols="12">
            <span class="summary-alert-value">{{ cardItems.merah }}</span>
          </v-col>
        </v-row>
        <!-- </v-alert> -->
      </v-col>
      <!-- <v-col cols="4"> -->
      <v-col>
        <!-- <v-alert border="bottom" colored-border color="#C53830" elevation="2"> -->
        <v-row class="white-xcards ml-2 mr-2">
          <v-col cols="12">
            <span
              class="summary-alert-title-black"
              v-html="'Charger SPKLU Non PLN'"
            ></span>
          </v-col>
          <v-col cols="12">
            <span class="summary-alert-value-black">{{ cardItems.biru }}</span>
          </v-col>
        </v-row>
        <!-- </v-alert> -->
      </v-col>
      <!-- <v-col>
        <v-alert border="bottom" colored-border color="#2671D9" elevation="2">
          <v-row class="white-xcards  ml-2 mr-2">
            <v-col cols="12">
              <span class="summary-alert-title-black" v-html="'Other'"></span>
            </v-col>
            <v-col cols="12">
              <span class="summary-alert-value-black">{{ cardItems.biru }}</span>
            </v-col>
          </v-row>
        </v-alert>
      </v-col> -->
    </v-row>
    <v-row v-if="!isFetching">
      <l-map
        ref="map"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="height: 600px; margin-top: 20px; z-index: 221"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker
          v-for="(marker, idx) in locationMarkerList"
          :key="idx"
          :options="{ opacity: 1.0, riseOnHover: true }"
          ref="markers"
          :lat-lng="marker.position"
        >
          <l-popup :options="{ closeButton: false }">
            <table class="popup-table">
              <tr>
                <td class="popup-property">SPKLU</td>
                <td class="popup-value">{{ capitalize(marker.nama) }}</td>
              </tr>
              <tr>
                <td class="popup-property">Jumlah Transaksi</td>
                <td class="popup-value">
                  {{ marker.jml_transaksi ? marker.jml_transaksi : 0 }}
                </td>
              </tr>
              <tr>
                <td class="popup-property">Jumlah Charger</td>
                <td class="popup-value">{{ marker.jml_charger }}</td>
              </tr>
              <tr>
                <td class="popup-property">Kapasitas Charger</td>
                <td class="popup-value">{{ capitalize(marker.daya) }}</td>
              </tr>
            </table>
            <div class="text-center">
              <a href="#" @click="openDialog(marker)">Cek Ketersediaan Plug</a>
            </div>
          </l-popup>
          <l-icon :icon-url="iconSelector(marker)" />
        </l-marker>
      </l-map>
    </v-row>
    <hr v-if="showMap" class="line-separator" />
    <span class="page-sub-title">{{ table_title }}</span>
    <v-row align="center" justify="center" class="mt-1">
      <v-col cols="3">
        <v-text-field
          append-icon="mdi-magnify"
          outlined
          solo
          hide-details
          v-model="search"
          class="search"
          placeholder="Search..."
          color="#2671D9"
        >
        </v-text-field>
      </v-col>
      <!-- <v-col>
        <v-btn
          class="ma-2"
          depressed
          outlined
          color="#2671D9"
          @click="openDialog()"
        >
          <v-icon left color="#2671D9">
            $ic-filter
          </v-icon>
          Filter
        </v-btn>
      </v-col> -->
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-btn
          class="ma-2"
          depressed
          outlined
          color="#2671D9"
          @click="exportExcel()"
        >
          <v-icon left color="#2671D9"> $ic-export-excel </v-icon>
          Export Excel
        </v-btn>
        <download-excel
          id="d"
          v-show="false"
          :data="itemsExcel"
          :name="'Detail Transaksi ' + this.dateExportFormat()"
          :header="'Detail Transaksi ' + this.dateExportFormat()"
        >
        </download-excel>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-5">
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="itemsPerPage"
          class="datatable"
          :search="search"
          item-key="id"
          hide-default-footer
          :page.sync="page"
          @page-count="pageCount = $event"
          show-expand
          @item-expanded="getSubTableBranch"
          single-expand
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-data-table
                :headers="subHeaders"
                :items="subItems"
                class="datatable mt-3 mb-3 ml-3 mr-3"
                hide-default-footer
                show-expand
                @item-expanded="getSubTableBranchCons"
                single-expand
                item-key="chargeboxId"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>Chargebox</v-toolbar-title>
                  </v-toolbar>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-data-table
                      :headers="subHeadersConn"
                      :items="subItemsConn"
                      class="datatable mt-3 mb-3 ml-3 mr-3"
                      hide-default-footer
                      item-key="namaKonektor"
                    >
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-toolbar-title>Connector</v-toolbar-title>
                        </v-toolbar>
                      </template>
                    </v-data-table>
                  </td>
                </template>
              </v-data-table>
            </td>
          </template>

          <template v-slot:item.jml_transaksi="{ item }">
            {{ formatCurrency(item.jml_transaksi).split(",")[0] }}
          </template>
        </v-data-table>
        <v-row>
          <v-col class="mt-5" cols="6">
            Menampilkan
            <v-select
              v-model="itemsPerPage"
              :items="[5, 10, 20, 30, 50]"
              dense
              solo
              flat
              class="ml-1 mr-1 size-select"
              @change="
                itemsPerPage = parseInt($event, 10);
                page = 1;
              "
            ></v-select>
            data dari <b>{{ items.length }}</b>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right mt-5" cols="6">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="5"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" class="text-right">
              <v-btn icon x-small @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="pb-0 pt-1">
                <v-list style="max-height: 200px; overflow: scroll">
                  <template v-for="(item, index) in chargeBoxList">
                    <v-list-item :key="index">
                      <v-icon v-if="item.isActive" class="mr-5"
                        >$ic-spklu-blue</v-icon
                      >
                      <v-icon v-else class="mr-5">$ic-spklu-red</v-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="item.namaChargebox"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="item.dayaChargebox"
                        ></v-list-item-subtitle>
                        <span
                          v-for="(connector, j) in item.connectors"
                          :key="connector.j"
                        >
                          <table>
                            <tr>
                              <td>{{ "(" + parseInt(j + 1) + ")" }}</td>
                              <td>Nama Connectors</td>
                              <td>: {{ connector.namaKonektor }}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Status Connectors</td>
                              <td>
                                :
                                <span>{{
                                  enumToStatus(connector.status)
                                }}</span>
                              </td>
                            </tr>
                          </table>
                        </span>
                      </v-list-item-content>
                      <!-- <v-list-item-action>
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                          </template>
                          <span v-for="(connector, j) in item.connectors" :key="connector.j">
                            <table>
                              <tr>
                                <td>{{ "(" + parseInt(j + 1) + ")" }}</td>
                                <td>Nama Connectors</td>
                                <td>: {{ connector.namaKonektor }}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Status Connectors</td>
                                <td>
                                  :
                                  <span>{{
                                    enumToStatus(connector.status)
                                  }}</span>
                                </td>
                              </tr>
                            </table>
                          </span>
                        </v-tooltip>
                      </v-list-item-action> -->
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            depressed
            :color="colorActive"
            dark
            @click="dialog = false"
          >
            Kembali
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogFilter" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>Filter Data</span>
            </v-col>
            <v-col class="text-right">
              <v-btn icon x-small @click="dialogFilter = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <!-- <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Jumlah Transaksi
                </div>
                <v-autocomplete
                  v-model="input.jml_transaksi"
                  :items="optionsJmlTransaksi"
                  label="Semua Jumlah Transaksi"
                  dense
                  solo
                  flat
                  outlined
                  item-text="name"
                  item-value="id"
                  return-object
                  cache-items
                  clearable
                  :color="colorActive"
                >
                </v-autocomplete>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Status
                </div>
                <v-autocomplete
                  v-model="input.is_active"
                  :items="optionsAvailability"
                  label="Semua Status"
                  dense
                  solo
                  flat
                  outlined
                  item-text="name"
                  item-value="id"
                  return-object
                  cache-items
                  clearable
                  :color="colorActive"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-5 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Unit
                </div>
                <v-text-field
                  v-model="input.searchBranch"
                  label="Cari Lokasi"
                  dense
                  solo
                  flat
                  outlined
                  clearable
                >
                </v-text-field>
                <span
                  >Selected:
                  {{
                    input.branch.name ? input.branch.name : "unit belum dipilih"
                  }}
                  <v-icon
                    v-show="input.branch.id"
                    @click="
                      input.branch = {};
                      active = [];
                    "
                    >mdi-close</v-icon
                  >
                </span>
                <div
                  v-show="!input.branch.id"
                  style="overflow-y: scroll; height: 300px"
                >
                  <v-treeview
                    activatable
                    :active="active"
                    :items="tempOptionsBranch"
                    @update:active="treeClick"
                  ></v-treeview>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Nama SPKLU
                </div>
                <v-autocomplete
                  v-model="input.spklu"
                  :items="optionsSpklu"
                  label="Semua SPKLU"
                  dense
                  solo
                  flat
                  outlined
                  item-text="name"
                  item-value="id"
                  return-object
                  :color="colorActive"
                  :search-input.sync="searchSpkluKeyword"
                  :loading="awaitingSearch"
                  clearable
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            depressed
            color="#999999"
            text
            @click="dialogFilter = false"
          >
            Kembali
          </v-btn>
          <v-btn
            small
            depressed
            :color="colorActive"
            @click="
              dialogFilter = false;
              reGetData();
            "
            dark
          >
            Cari
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
  </div>
</template>
<script>
import 'leaflet/dist/leaflet.css'
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from 'vue2-leaflet'
import SpkluService from '@/services/default/SpkluService'
import RefService from '@/services/default/RefService'
import { StorageService } from '@/services/storage.service'

const spkluService = SpkluService.build()
const refService = RefService.build()
export default {
  name: 'spklu-availability-spklu',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon
  },
  data: () => ({
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    cardItems: {
      hijau: 0,
      kuning: 0,
      merah: 0,
      biru: 0
    },
    expanded: [],
    singleExpand: false,
    singleExpand2: false,
    headers: [
      // { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'nama', text: 'Nama SPKLU', align: 'left' },
      { value: 'jml_charger', text: 'Jumlah Charger', align: 'center' },
      { value: 'jml_connector', text: 'Jumlah Connector', align: 'center' },
      { value: 'jml_transaksi', text: 'Jumlah Transaksi', align: 'center' },
      { value: 'kategori', text: 'Kategori SPKLU', align: 'center' },
      { value: 'status', text: 'Status SPKLU', align: 'center' },
      { value: 'data-table-expand', text: '', align: 'center' }
    ],
    subHeaders: [
      { value: 'chargeboxId', text: 'ID', align: 'left' },
      { value: 'namaChargebox', text: 'Nama', align: 'left' },
      { value: 'dayaChargebox', text: 'Daya', align: 'left' },
      { value: 'isActive', text: 'Active', align: 'left' },
      { value: 'data-table-expand', text: '', align: 'center' }
    ],
    subHeadersConn: [
      { value: 'namaKonektor', text: 'Nama', align: 'left' },
      { value: 'typeConnector', text: 'Type', align: 'left' },
      { value: 'statusDetail', text: 'Status', align: 'left' }
    ],
    items: [],
    subItems: [],
    subItemsConn: [],
    subItemsPerPage: 10,
    activaTableCharge: false,
    subPage: 1,
    subPageCount: 0,
    subSearch: '',
    search: '',
    sortSettings: '',
    isFetching: false, // for datatable
    locationMarkerList: [],
    switchMe: true,
    // map properties
    zoom: 5,
    center: latLng(-2.372369, 115.421875),
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showParagraph: false,
    mapOptions: {
      // zoomSnap: 0.5
      zoomControl: true,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: true,
      boxZoom: false,
      keyboard: false,
      dragging: true
    },
    showMap: false,
    isShowPage: false,
    mapObj: {},
    table_title: '',
    timer: '',
    // dialog properties
    dialog: false,
    dialogTitle: '',
    chargeBoxList: [],
    showTooltip: false,
    // client side pagination properties
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    // filter
    input: {
      jml_transaksi: {},
      branch: {},
      spklu: {},
      searchBranch: '',
      is_active: {}
    },
    dialogFilter: false,
    optionsJmlTransaksi: [
      { id: 'hijau', name: 'Available' },
      { id: 'kuning', name: 'Maintenance' },
      { id: 'merah', name: 'Non PLN' },
      { id: 'biru', name: 'Other' }
    ],
    optionsAvailability: [
      { id: 'active', name: 'Available' },
      { id: 'inuse', name: 'In Use' },
      { id: 'inactive', name: 'Unavailable' }
    ],
    optionsSpklu: [],
    optionsLokasi: [],
    optionsBranch: [],
    tempOptionsBranch: [],
    searchSpkluKeyword: '',
    awaitingSearch: false,
    active: [],
    itemsExcel: [],
    timersAuto: ''
  }),
  async created () {
    this.table_title = 'Detail SPKLU'
    this.isShowPage = true
    this.showMap = true
    this.getSpkluCoordinate()
    this.getSpkluCard()
    this.getBranchList()
    this.setTimerUpdate()
  },
  computed: {},
  mounted: async function () {
    const responseAuth = await StorageService.getAuthdata()
    const newVal = this.input.branch.id
    const oldVal = responseAuth.branch.idBranch
    await this.reGetData()

    if (newVal === undefined) {
      if (responseAuth.branch.name !== 'PUSAT') {
        this.input.branch.id = responseAuth.branch.idBranch
        this.input.branch.name = responseAuth.branch.name
      }
      await this.getOptionsSpklu(oldVal)
      await this.reGetData()
    }

    // if (this.$route.path === '/dashboard/spklu-fast-charging') {
    //   this.$nextTick(() =>  {
    //     this.map = this.$refs.map.mapObject
    //     this.mapObj = this.map
    //   })
    //   // re-get data every 1 minute
    //   this.timer = setInterval(() => {
    //     this.resetData()
    //     // this.getSpkluACHomeCharging()
    //     const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
    //     if (tableQuery) {
    //       this.getDataTable(tableQuery.page, tableQuery.size)
    //     } else {
    //       this.getDataTable()
    //     }
    //     this.isShowPage = true
    //   }, 60000)
    // }
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    'input.branch': function (newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        this.getOptionsSpklu(newVal.id)
      }
    },
    'input.searchBranch': function (val) {
      if (!val) {
        this.tempOptionsBranch = this.optionsBranch
      } else {
        this.tempOptionsBranch = this.containComplex(this.optionsBranch, val)
      }
    }
    // searchSpkluKeyword (val) {
    //   const self = this
    //   if (!this.awaitingSearch) {
    //     setTimeout(() => {
    //       if (val !== '' && val !== null) {
    //         self.getOptionsSpklu()
    //       }
    //       self.awaitingSearch = false
    //     }, 1000)
    //   }
    //   this.awaitingSearch = true
    // }
  },
  methods: {
    clickRow (item, event) {
      if (event.isExpanded) {
        const index = this.expanded.findIndex((i) => i === item)
        this.expanded.splice(index, 1)
      } else {
        this.expanded.push(item)
      }
    },
    async getSpkluCoordinate (param) {
      this.isFetching = true

      const response = await spkluService.getLocationSpklu(param)
      const {
        data: { data }
      } = response

      //   var categoryLength = data.filter((item) => item.status == "maintenance");
      //   var categoryLength = data.filter((item) => item.status == "available");
      //   var categoryLength = data.filter((item) => item.status == "offline mode");
      // this.cardItems = {
      //   hijau: data.filter((item) => item.status == "available").length,
      //   kuning: data.filter((item) => item.status == "inuse").length,
      //   merah: data.filter((item) => item.status == "maintenance" || item.status == "unavailable").length,
      //   biru: data.filter((item) => item.status == "offline mode").length
      // };
      //   console.log(categoryLength.length);

      //   console.log(data);
      // let firstLoad = true
      this.locationMarkerList = []
      for (let i = 0; i < data.length; i++) {
        // set location marker
        const position = latLng(data[i].latitude, data[i].longitude)

        // find existing index
        const idx = this.locationMarkerList.findIndex(
          (x) => x.id === data[i].spkluId
        )
        if (idx === -1) {
          const newmarker = {
            id: data[i].idSpklu,
            nama: data[i].namaSpklu,
            alamat: data[i].alamatSpklu,
            daya: data[i].dayaSpklu,
            status: data[i].status,
            jml_transaksi: data[i].transaksi,
            jml_charger: data[i].charger,
            jml_connector: data[i].connector,
            kategori: data[i].kategori,
            position: position,
            latitude: data[i].latitude,
            longitude: data[i].longitude,
            partition: data[i].partition
          }
          this.locationMarkerList.push(newmarker)
        } else if (idx > -1) {
          // firstLoad = false
          this.locationMarkerList[idx].jml_transaksi = data[i].transaksi
          this.locationMarkerList[idx].status = data[i].status
        }
      }

      // if (firstLoad) {
      //   if (this.zoom === 4) {
      //     this.zoom += 1
      //   } else {
      //     const self = this
      //     this.zoom -= 1
      //     setTimeout(function () {
      //       self.zoom += 1
      //     }, 300)
      //   }
      // }

      // set datatable client side data
      this.items = this.locationMarkerList.sort(function (a, b) {
        return b.jml_transaksi - a.jml_transaksi
      })

      const temp = this.items
      // reform data for excel export
      this.itemsExcel = await temp.map((item, index) => {
        return {
          Nomor: index + 1,
          'ID SPKLU': item.id,
          Nama: item.nama,
          Alamat: item.alamat,
          'Kapasitas (kW)': item.daya,
          Status: item.status,
          'Jumlah Transaksi': item.jml_transaksi,
          'Jumlah Charger': item.jml_charger,
          'Jumlah Connector': item.jml_connector,
          'Kategori SPKLU': item.kategori,
          'Status SPKLU': item.status,
          Latitude: item.latitude,
          Longitude: item.longitude
        }
      })

      this.isFetching = false
    },
    async openDialog (marker) {
      await this.getSpkluAvailabilityCheck(marker.id)
      this.dialogTitle = marker.nama
      this.dialog = true
    },
    async getSpkluAvailabilityCheck (id) {
      const param = {
        idSpklu: id
      }
      const response = await spkluService.getDetailAvailabilitySpklu(param)
      const {
        data: { data }
      } = response
      this.chargeBoxList = data
    },
    async getSubTableBranch ({ item }) {
      // this.activaTableCharge = true;
      const param = {
        idSpklu: item.id
      }
      const response = await spkluService.getDetailAvailabilitySpklu(param)
      const {
        data: { data }
      } = response
      this.subItems = data
    },
    async getSubTableBranchCons ({ item }) {
      this.subItemsConn = item.connectors
    },
    async getSpkluAvailability (id) {
      const param = {
        idSpklu: id
      }
      const response = await spkluService.getDetailAvailabilitySpklu(param)
      const {
        data: { data }
      } = response
      this.subItemsPerPage = data
    },
    iconSelector (data) {
      if (data.partition === 'true') {
        return '/maps/ic-spklu-half.svg'
      } else if (data.status === 'offline mode') {
        return '/maps/ic-spklu-blue.svg'
      } else if (data.status === 'available') {
        return '/maps/ic-spklu-green.svg'
      } else if (data.status === 'inuse') {
        return '/maps/ic-spklu-yellow.svg'
      } else {
        return '/maps/ic-spklu-red.svg'
      }
    },
    async getSpkluCard (param) {
      const response = await spkluService.getAvabilityCard(param)
      const data = response.data.data
      this.cardItems = {
        hijau: data.available,
        kuning: data.inUse,
        merah: data.unavailable,
        biru: data.nonPln
      }
    },
    async resetData () {
      this.cardItems = [
        {
          value: 0,
          status: 1,
          title: 'available',
          order_number: 0
        },
        {
          value: 0,
          status: 2,
          title: 'in_use',
          order_number: 1
        },
        {
          value: 0,
          status: 4,
          title: 'unavailable',
          order_number: 2
        }
      ]
      this.items = {}
    },
    async exportExcel () {
      document.getElementById('d').click()
    },
    openDialogFilter () {
      this.dialogFilter = true
    },
    // async getCompanyList () {
    //   const response = await refService.getCompanyList()
    //   const { data: { data } } = response
    //   const temp = data.map(item => {
    //     return {
    //       id: item.idCompany,
    //       text: item.name
    //     }
    //   })
    //   this.filterOptions.company = temp
    // },
    async getBranchList () {
      const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
      if (branch) {
        this.optionsBranch = branch
        this.tempOptionsBranch = branch
      } else {
        const param = {
          companyId: 1,
          branchId: ''
        }
        const response = await refService.getBranchList(param)
        const {
          data: { data }
        } = response

        const temp = data.map((item) => {
          // remap level 1
          item.child = item.child.map((item2) => {
            // remap level 2
            item2.child = item2.child.map((item3) => {
              // remap level 3
              item3.child = item3.child.map((item4) => {
                // remap level 4
                return {
                  id: item4.id,
                  name: item4.id.split('').join('.') + ' - ' + item4.name,
                  children: item4.child
                }
              })
              return {
                id: item3.id,
                name: item3.id.split('').join('.') + ' - ' + item3.name,
                children: item3.child
              }
            })
            return {
              id: item2.id,
              name: item2.id.split('').join('.') + ' - ' + item2.name,
              children: item2.child
            }
          })
          return {
            id: item.id,
            name: item.id.split('').join('.') + ' - ' + item.name,
            children: item.child
          }
        })

        this.optionsBranch = temp
        this.tempOptionsBranch = temp

        localStorage.setItem(
          'branch_list',
          JSON.stringify({
            data: temp
          })
        )
      }
    },
    treeClick (value) {
      if (value.length > 0) {
        const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
        this.input.branch = this.findComplex(branch, value[0])
      }
    },
    async getOptionsSpklu (id) {
      this.paging.page = 0
      this.paging.size = 999

      // const param = Object.assign({ q: this.searchSpkluKeyword }, this.paging)
      const param = Object.assign({ q: id }, this.paging)
      const response = await refService.getSpkluList(param)
      const { data } = response
      if (data.success !== true) return

      if (this.input.branch.id !== param.q || param.q === undefined) {
        this.optionsSpklu = []
      } else {
        this.optionsSpklu = data.data.content.map((data) => {
          return {
            id: data.idSpklu,
            name: data.spkluName
          }
        })
      }
    },
    triggerAuto () {
      this.switchMe = !this.switchMe
      if (this.switchMe == true) {
        this.setTimerUpdate()
      } else {
        this.destroyTimerUpdate()
      }
    },
    setTimerUpdate () {
      this.timersAuto = window.setInterval(() => {
        this.reGetData() // call any function or end point
      }, 120000)
    },
    destroyTimerUpdate () {
      clearInterval(this.timersAuto)
    },
    async reGetData () {
      let q = ''

      if (this.input.spklu && this.input.spklu.id) {
        q = this.input.spklu.id
      } else if (this.input.branch && this.input.branch.id) {
        q = this.input.branch.id
      }

      const isActive = this.input.is_active ? this.input.is_active.id : ''
      const param = {
        // card: this.input.jml_transaksi ? this.input.jml_transaksi.id : "",
        q: q,
        isActive: isActive
      }

      await this.getSpkluCoordinate(param)
      await this.getSpkluCard({ q: param.q })
    }
  }
}
</script>
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0); /* Hitam transparan */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
      radial-gradient(farthest-side,#707070 94%,#0000) top/8px 8px no-repeat,
      conic-gradient(#0000 30%,#707070);
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);
  animation: l13 1s infinite linear;
}
@keyframes l13{
  100%{transform: rotate(1turn)}
}

.summary-alert-title {
  font-weight: 400;
  font-size: 14px;
  color: #f9f9f9;
}

.summary-alert-value {
  font-weight: 600;
  font-size: 24px;
  color: #ffffff;
}

.summary-alert-title-black {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.summary-alert-value-black {
  font-weight: 600;
  font-size: 24px;
  color: #000000;
}

.search {
  height: 48px;
}

.leaflet-popup-close-button {
  color: none;
}

.leaflet-container {
  font-family: "Inter";
}

.popup-property {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #9a9a9a;
}

.popup-value {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #000000;
}

.popup-table tr td {
  padding: 5px;
}

.v-dialog__content--active {
  z-index: 224 !important;
}

.vue2leaflet-map {
  z-index: 200 !important;
}

.red-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/red-box.svg");
  /* background: linear-gradient(259deg, #FF5E5E 52.44%, #FF9898 100%); */
}

.yellow-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/yellow-box.svg");
  /* background: linear-gradient(255deg, #F3AF00 51.62%, #FFE39A 100%); */
}

.green-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/green-box.svg");
  /* background: linear-gradient(257deg, #5BBA2E 53.55%, #AAE190 100%); */
}

.white-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/white-box.svg");
  /* background: linear-gradient(261deg, #D9D9D9 50%, #F5F5F5 100%); */
}
</style>
